export const FONT_SIZE_STEP = 6.25;

export const FONT_SIZES = {
  SMALLER: 87.5,
  SMALL: 93.75,
  REGULAR: 100,
  LARGE: 106.25,
  LARGER: 112.5,
};

// for FONT_SIZES.REGULAR
export const CHAPTER_FONT_SIZE = {
  text: 21,
  title: 40,
  subTitle: 20,
};

export const NON_CHAPTER_FONT_SIZE = {
  text: 32,
  title: 40,
  subTitle: 20,
};

export const FONT_SIZE_LIST = ['SMALLER', 'SMALL', 'REGULAR', 'LARGE', 'LARGER'];
